import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";
import { faImage } from "@fortawesome/free-solid-svg-icons";
import { Fragment, useContext } from "react";
import AuthContext from "context/AuthContext";
import { artworkDesignGlobalPermissions } from "../../master-artwork/helpers/artworkPermissions";


export const ArtworkMenu = () => {
  const authContext = useContext(AuthContext);
  const baseRoute = "artwork";

  const hasCreatorPermission = artworkDesignGlobalPermissions.every(
    (permission) => authContext?.hasPermission(permission),
  );

  const artworkRoutes = [
    {
      label: "Search Artwork",
      route: `/`,
      onclicked: "",
      permissions: artworkDesignGlobalPermissions,
    },
    {
      label: "Create New Collection",
      route: `collections/create`,
      onclicked: "",
      permissions: artworkDesignGlobalPermissions,
    },
    // {
    //   label: "Create new Meta Artwork Name and Number",
    //   route: `meta-artwork/create`,
    //   onclicked: "",
    //   permissions: artworkDesignGlobalPermissions,
    // },
    {
      label: "Create New Artwork",
      route: `printing-technique/create`,
      onclicked: "",
      permissions: artworkDesignGlobalPermissions,
    },
    // {
    //   label: "Search & Edit",
    //   route: "search",
    //   onclicked: "",
    //   permissions: artworkDesignGlobalPermissions,
    // },
    {
      label: "My approval requests",
      route: "/approvals",
      onclicked: "",
      permissions: artworkDesignGlobalPermissions,
    },
  ];

  return (
    <>
      {hasCreatorPermission && (
        <li className="nav-item">
          <a
            className="nav-link collapsed"
            href="#"
            data-toggle="collapse"
            data-target="#collapseARTWORKMASTER"
            aria-expanded="false"
            aria-controls="collapseARTWORKMASTER"
          >
            <FontAwesomeIcon icon={faImage} className="fas fa fa-fw" />
            <span>Artwork</span>
          </a>
          <div
            id="collapseARTWORKMASTER"
            className="collapse"
            aria-labelledby="headingARTWORKMASTER"
            data-parent="#accordionSidebar"
          >
            <div className="bg-white py-2 collapse-inner rounded">
              <h6 className="collapse-header">Master Artwork</h6>
              {artworkRoutes.map((menuItem: any, index) => {

                const hasItemPermission = menuItem.permissions.every(
                  (permission: string) => authContext?.hasPermission(permission),
                );

                return (
                  <Fragment key={index}>
                    {hasItemPermission ? (
                      <NavLink
                        // key={index}
                        className="collapse-item text-wrap"
                        to={`${baseRoute}/${menuItem.route}`}
                        onClick={menuItem.onclicked}
                        data-toggle="collapse"
                        data-target="#collapseARTWORKMASTER"
                        aria-expanded="true"
                        aria-controls="collapseARTWORKMASTER"
                      >
                        {menuItem.label}
                      </NavLink>
                    ) : (
                      <></>
                    )}
                  </Fragment>
                );
              })}
            </div>
          </div>
        </li>
      )}
    </>
  );
};
